/**
 * @generated SignedSource<<ad2b4cd8fea03df03bf787adf5e9f384>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedItemTile_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BuyerProductCarousel_user" | "useFavoritesItem_user">;
  readonly " $fragmentType": "SharedItemTile_user";
};
export type SharedItemTile_user$key = {
  readonly " $data"?: SharedItemTile_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedItemTile_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "showMerchandizingTool"
    },
    {
      "kind": "RootArgument",
      "name": "showSeller"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedItemTile_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useFavoritesItem_user"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "showMerchandizingTool",
          "variableName": "showMerchandizingTool"
        },
        {
          "kind": "Variable",
          "name": "showSeller",
          "variableName": "showSeller"
        }
      ],
      "kind": "FragmentSpread",
      "name": "BuyerProductCarousel_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "557ef59bafdb6bab7cf7c864de7fe0ab";

export default node;
